import React, { Component } from 'react';
import { Card, ListGroup } from 'react-bootstrap';

export class Emergency extends Component {
    render() {
      return <div>
          <h3>Emergency Preparedness Tips</h3>
          <br />
          <Card>
            <Card.Title>Helpful and reliable links:</Card.Title>
            <ListGroup>
                <ListGroupLinkItem text="Liahona Feb 2021 (pg U4-U7): Insurance and Reassurance" link="https://www.churchofjesuschrist.org/study/liahona/2021/02/united-states-and-canada-section/insurance-and-reassurance?lang=eng" />
                <ListGroupLinkItem text="Church of Jesus Christ of Latter-day Saints’ preparedness website" link="https://www.churchofjesuschrist.org/study/manual/gospel-topics/emergency-preparedness?lang=eng" />
                <ListGroupLinkItem text="Federal Emergency Management Agency" link="https://www.ready.gov" />
                <ListGroupLinkItem text="FEMA - Pandemics. This site also a list of specific disasters and how to prepare foreach of the disasters." link="https://www.ready.gov/pandemic" />
            </ListGroup>
        </Card>
        <Card>
            <Card.Title>Options on Family Emergency Planning:</Card.Title>
            <ListGroup>
                <ListGroupLinkItem text="A family emergency plan prepared by the Orange County Fire Authority (OCFA)" link="https://s3-us-west-2.amazonaws.com/www.lfward.org/Documents/Family-Household-Disaster-Plan.pdf" />
                <ListGroupLinkItem text="Federal Emergency Management Agency Model" link="https://www.ready.gov/plan" />
            </ListGroup>
        </Card>
    </div>;
    }
  }

  export class ListGroupLinkItem extends Component {
      render() {
      return <ListGroup.Item>
          <a href={this.props.link} target="_blank" rel="noopener noreferrer">{this.props.text}</a>
          </ListGroup.Item>
      }
  }

  export default Emergency;